import * as React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../form";
import moment from "moment-timezone";
import styles from "./styles.module.scss";

interface AddToCalendarProps {
}

const AddToCalendar: React.FC<AddToCalendarProps> = () => {
  const validationSchema = Yup.object().shape({
    date: Yup.string()
      .required("Start date is required")
      .test("is-future-date", "Start date must be today or later", (value) => {
        return moment(value).isSameOrAfter(moment(), 'day');
      }),
    time: Yup.string().required("Time is required"),
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      date: moment().format('YYYY-MM-DD'),
      time: "02:00",
    },
  });

  const onFormSubmit = (data: { date: string; time: string; }) => {
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className={styles.calendarContainer}>
          <Input
            placeholder=""
            type="date"
            name="date"
            register={register}
            validatorMessage={errors.date?.message || ""}
            label="Date"
            showRequired
            parentClassName={styles.dateInputWrapper}
            className={styles.dateInput}
            min={moment().format('YYYY-MM-DD')}
          />
          <Input
            placeholder=""
            type="time"
            name="time"
            register={register}
            validatorMessage={errors.time?.message || ""}
            label="Time"
            showRequired
            parentClassName={styles.dateInputWrapper}
            className={styles.dateInput}
          />
        </div>
        <div className={styles.footer}>
          <button className={` px-4 py-2 ${styles.dateSubmit}`} type="submit">Done</button>
        </div>
      </form>
    </div>
  );
};

export { AddToCalendar };